import { wikiToPlainText } from '@/util/tokenize_wiki_text'
export {
  ObjectiveLevelValues,
  isValidObjectiveLevel,
  levelButtonClass,
  objectiveTargetLabel,
  generationTargetText
}

const ObjectiveLevelValues = {
  QUARTER_1ST: '1st',
  QUARTER_2ND: '2nd',
  QUARTER_3RD: '3rd',
  QUARTER_4TH: '4th'
}

const validObjectiveLevels = [
  ObjectiveLevelValues.QUARTER_1ST,
  ObjectiveLevelValues.QUARTER_2ND,
  ObjectiveLevelValues.QUARTER_3RD,
  ObjectiveLevelValues.QUARTER_4TH
]
function isValidObjectiveLevel(level) {
  return validObjectiveLevels.includes(level)
}

function levelButtonClass(level) {
  if (level === ObjectiveLevelValues.QUARTER_1ST) {
    return 'btn-teal'
  }
  if (level === ObjectiveLevelValues.QUARTER_2ND) {
    return 'btn-blue'
  }
  if (level === ObjectiveLevelValues.QUARTER_3RD) {
    return 'btn-purple'
  }
  return ''
}

// "Quarter 2 Objective" -- the form used to name a generation target, kept parallel with
// the annual target's "Annual Target" label rather than using the objective's own title.
// Falls back to a plain "Objective" for a level this map does not cover, so an unexpected
// level degrades to a generic label instead of "Quarter undefined Objective".
const quarterNumbersByLevel = {
  [ObjectiveLevelValues.QUARTER_1ST]: '1',
  [ObjectiveLevelValues.QUARTER_2ND]: '2',
  [ObjectiveLevelValues.QUARTER_3RD]: '3',
  [ObjectiveLevelValues.QUARTER_4TH]: '4'
}

// hasOwnProperty rather than a bare lookup: a bare read reaches Object.prototype, so a
// level of 'constructor', 'toString' or '__proto__' resolves to a truthy inherited value
// and produces labels like "Quarter function Object() { [native code] } Objective".
function objectiveTargetLabel(level) {
  const hasQuarter = Object.prototype.hasOwnProperty.call(quarterNumbersByLevel, level)
  return hasQuarter ? `Quarter ${quarterNumbersByLevel[level]} Objective` : 'Objective'
}

// The text a generation target is described by, and generated from.
//
// Two things it gets right that a bare `edited || fallback` does not. An edited value of
// '' is a target the teacher deliberately cleared, so it must not resurrect the pre-edit
// text -- only an ABSENT edit falls back. And the stored text is wiki text, carrying
// [[label|text]] brackets and <sup> markup that would otherwise be shown raw in the
// modal and sent verbatim to the model.
function generationTargetText(editedText, fallbackText) {
  const source = editedText === undefined || editedText === null ? fallbackText : editedText
  return source ? wikiToPlainText(source) : ''
}
